{
  "background": {
    "primary": "#ffffff",
    "secondary": "#f5f6f4",
    "brand": {
      "primary": "#80eaff",
      "secondary": "#b2f2ff"
    },
    "brandExtra": {
      "primary": "#7055f6",
      "secondary": "#bfb2ff"
    },
    "inverse": "#000000",
    "static": {
      "dark": "#000000",
      "light": "#ffffff"
    },
    "success": {
      "primary": "#95ff80",
      "secondary": "#bfffb2"
    },
    "warning": {
      "primary": "#ffc380",
      "secondary": "#ffdbb2"
    },
    "alert": {
      "primary": "#f65570",
      "secondary": "#ff8095"
    },
    "neutral": {
      "primary": "#a9aca0",
      "secondary": "#ecede9"
    }
  },
  "content": {
    "primary": "#000000",
    "secondary": "#5b5d56",
    "tertiary": "#909385",
    "brand": {
      "primary": "#1b8398",
      "secondary": "#31cae8"
    },
    "brandExtra": {
      "primary": "#7055f6",
      "secondary": "#9580ff"
    },
    "inverse": "#ffffff",
    "static": {
      "light": "#ffffff",
      "dark": "#000000"
    },
    "success": {
      "primary": "#368f24",
      "secondary": "#50e831"
    },
    "warning": {
      "primary": "#c37822",
      "secondary": "#f6ab55"
    },
    "alert": {
      "primary": "#c3223d",
      "secondary": "#f65570"
    },
    "neutral": {
      "primary": "#76786d",
      "secondary": "#a9aca0"
    },
    "on": {
      "brand": "#000000",
      "brandExtra": "#ffffff",
      "success": "#000000",
      "warning": "#000000",
      "alert": "#ffffff",
      "neutral": "#000000"
    }
  },
  "border": {
    "primary": "#000000",
    "secondary": "#dddfd8",
    "brand": "#31cae8",
    "brandExtra": "#5031e8",
    "inverse": "rgba(255, 255, 255, 0.17)",
    "success": "#3dc322",
    "warning": "#c37822",
    "alert": "#c3223d",
    "neutral": "#a9aca0"
  },
  "overlay": {
    "mono": "rgba(0, 0, 0, 0.05)",
    "brand": "rgba(128, 234, 255, 0.3)",
    "brandExtra": "rgba(149, 128, 255, 0.3)",
    "success": "rgba(149, 255, 128, 0.24)",
    "warning": "rgba(255, 195, 128, 0.28)",
    "alert": "rgba(232, 48, 79, 0.24)",
    "neutral": "rgba(169, 172, 160, 0.24)",
    "monoHover": "rgba(0, 0, 0, 0.1)"
  },
  "layer": {
    "scrim": "rgba(0, 0, 0, 0.75)",
    "float": "rgba(255, 255, 255, 0.95)"
  },
  "control": {
    "brand": {
      "primary": {
        "bg": "#80eaff",
        "bgHover": "#55dcf6",
        "bgPress": "#31cae8",
        "bgDisable": "rgba(221, 223, 216, 0.65)",
        "border": "#31cae8",
        "borderHover": "#22a8c3",
        "borderPress": "rgba(34, 168, 195, 0)",
        "borderDisable": "rgba(221, 223, 216, 0)"
      },
      "secondary": {
        "bg": "#d6f8ff",
        "bgHover": "#b2f2ff",
        "bgPress": "#80eaff",
        "border": "#b2f2ff",
        "borderHover": "#80eaff",
        "borderPress": "rgba(128, 234, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(235, 252, 255, 0)",
        "bgHover": "#ebfcff",
        "bgPress": "#d6f8ff",
        "border": "rgba(235, 252, 255, 0)",
        "borderHover": "rgba(235, 252, 255, 0)",
        "borderPress": "rgba(214, 248, 255, 0)"
      },
      "text": {
        "primary": "#000000",
        "secondary": "#000000",
        "tertiary": "#000000",
        "disable": "rgba(0, 0, 0, 0.3)",
        "ghost": "#22a8c3"
      },
      "ghost": {
        "bg": "rgba(0, 0, 0, 0)",
        "bgHover": "rgba(34, 168, 195, 0.04)",
        "bgPress": "rgba(34, 168, 195, 0.08)",
        "border": "rgba(34, 168, 195, 0.1)",
        "borderHover": "rgba(34, 168, 195, 0.16)",
        "borderPress": "rgba(34, 168, 195, 0.1)"
      }
    },
    "mono": {
      "primary": {
        "bg": "#1a1a19",
        "bgHover": "#272725",
        "bgPress": "#41423e",
        "border": "rgba(26, 26, 25, 0)",
        "borderHover": "rgba(39, 39, 37, 0)",
        "borderPress": "rgba(65, 66, 62, 0)"
      },
      "secondary": {
        "bg": "#ecede9",
        "bgHover": "#dddfd8",
        "bgPress": "#c2c4ba",
        "border": "#dddfd8",
        "borderHover": "#c2c4ba",
        "borderPress": "rgba(194, 196, 186, 0)"
      },
      "tertiary": {
        "bg": "rgba(236, 237, 233, 0)",
        "bgHover": "#ecede9",
        "bgPress": "#dddfd8",
        "border": "rgba(236, 237, 233, 0)",
        "borderHover": "rgba(236, 237, 233, 0)",
        "borderPress": "rgba(221, 223, 216, 0)"
      },
      "text": {
        "primary": "#ffffff",
        "secondary": "#000000",
        "tertiary": "#000000",
        "ghost": "#000000"
      },
      "ghost": {
        "bg": "rgba(0, 0, 0, 0)",
        "bgHover": "rgba(0, 0, 0, 0.04)",
        "bgPress": "rgba(0, 0, 0, 0.08)",
        "border": "rgba(0, 0, 0, 0.1)",
        "borderHover": "rgba(0, 0, 0, 0.16)",
        "borderPress": "rgba(0, 0, 0, 0.1)"
      }
    },
    "brandExtra": {
      "primary": {
        "bg": "#7055f6",
        "bgHover": "#5031e8",
        "bgPress": "#3d22c3",
        "border": "#5031e8",
        "borderHover": "#3d22c3",
        "borderPress": "rgba(61, 34, 195, 0)"
      },
      "secondary": {
        "bg": "#ddd6ff",
        "bgHover": "#bfb2ff",
        "bgPress": "#9580ff",
        "border": "#bfb2ff",
        "borderHover": "#9580ff",
        "borderPress": "rgba(149, 128, 255, 0)"
      },
      "tertiary": {
        "bg": "rgba(238, 235, 255, 0)",
        "bgHover": "#eeebff",
        "bgPress": "#ddd6ff",
        "border": "rgba(238, 235, 255, 0)",
        "borderHover": "rgba(238, 235, 255, 0)",
        "borderPress": "rgba(221, 214, 255, 0)"
      },
      "text": {
        "primary": "#ffffff",
        "secondary": "#000000",
        "tertiary": "#301b98",
        "ghost": "#79971b"
      },
      "ghost": {
        "bg": "rgba(0, 0, 0, 0)",
        "bgHover": "rgba(121, 151, 27, 0.04)",
        "bgPress": "rgba(121, 151, 27, 0.08)",
        "border": "rgba(121, 151, 27, 0.1)",
        "borderHover": "rgba(121, 151, 27, 0.16)",
        "borderPress": "rgba(121, 151, 27, 0.1)"
      }
    },
    "alert": {
      "bg": "#ffb2bf",
      "border": "#f65570",
      "primary": {
        "bg": "#e8304f",
        "bgHover": "#c3223d",
        "bgPress": "#8f2436",
        "border": "#c3223d",
        "borderHover": "#8f2436",
        "borderPress": "rgba(152, 27, 48, 0)"
      },
      "secondary": {
        "bg": "#ffd6dd",
        "bgHover": "#ffb2bf",
        "bgPress": "#ff8095",
        "border": "#ffb2bf",
        "borderHover": "#ff8095",
        "borderPress": "rgba(255, 128, 149, 0)"
      },
      "tertiary": {
        "bg": "rgba(255, 235, 238, 0)",
        "bgHover": "#ffebee",
        "bgPress": "#ffd6dd",
        "border": "rgba(255, 214, 221, 0)",
        "borderHover": "rgba(255, 214, 221, 0)",
        "borderPress": "rgba(255, 214, 221, 0)"
      },
      "text": {
        "primary": "#ffffff",
        "secondary": "#000000",
        "tertiary": "#8f2436",
        "ghost": "#c33d22"
      },
      "ghost": {
        "bg": "rgba(0, 0, 0, 0)",
        "bgHover": "rgba(195, 61, 34, 0.04)",
        "bgPress": "rgba(195, 61, 34, 0.08)",
        "border": "rgba(195, 61, 34, 0.1)",
        "borderHover": "rgba(195, 61, 34, 0.16)",
        "borderPress": "rgba(195, 61, 34, 0.1)"
      }
    },
    "input": {
      "bg": "rgba(0, 0, 0, 0.08)",
      "bgHover": "rgba(0, 0, 0, 0.15)",
      "bgDisable": "rgba(0, 0, 0, 0.2)",
      "border": "rgba(0, 0, 0, 0.1)",
      "borderHover": "rgba(0, 0, 0, 0.15)",
      "borderDisable": "rgba(221, 223, 216, 0)",
      "text": "#000000",
      "placeholder": "rgba(0, 0, 0, 0.6)",
      "textDisable": "rgba(0, 0, 0, 0.2)"
    },
    "focus": {
      "bg": "#ffffff",
      "border": "#31cae8"
    },
    "check": {
      "bg": "rgba(128, 234, 255, 0.15)",
      "bgHover": "rgba(128, 234, 255, 0.3)",
      "bgDisable": "rgba(221, 223, 216, 0.65)",
      "border": "#80eaff",
      "borderHover": "#55dcf6",
      "borderDisable": "rgba(221, 223, 216, 0)",
      "icon": "#31cae8"
    },
    "faint": {
      "bg": "#ecede9",
      "bgHover": "#dddfd8",
      "border": "#dddfd8",
      "borderHover": "#c2c4ba"
    },
    "slider": {
      "bg": "#1a1a19",
      "bgHover": "#272725",
      "bgDisable": "#dddfd8"
    },
    "switch": {
      "bg": "rgba(128, 234, 255, 0.15)",
      "bgHover": "rgba(128, 234, 255, 0.3)",
      "bgDisable": "rgba(221, 223, 216, 0.65)",
      "border": "#80eaff",
      "borderHover": "#55dcf6",
      "borderDisable": "rgba(221, 223, 216, 0)"
    },
    "knob": {
      "bg": "#1a1a19",
      "bgHover": "#272725",
      "bgActive": "#55dcf6",
      "bgActiveHover": "#31cae8",
      "bgInactive": "#c2c4ba",
      "bgInactiveHover": "#a9aca0",
      "bgDisable": "#dddfd8"
    },
    "text": {
      "primary": "#000000",
      "disable": "rgba(0, 0, 0, 0.2)"
    },
    "link": {
      "primary": "#1b8398",
      "primaryHover": "#55dcf6",
      "secondary": "#5031e8",
      "secondaryHover": "#9580ff"
    },
    "segmented": {
      "bg": "rgba(255, 255, 255, 0.08)",
      "bgHover": "#dddfd8",
      "bgActive": "rgba(128, 234, 255, 0.15)",
      "border": "rgba(255, 255, 255, 0.1)",
      "borderHover": "#c2c4ba",
      "borderActive": "#80eaff",
      "text": "#000000",
      "textDisable": "rgba(0, 0, 0, 0.2)"
    },
    "tagLabel": {
      "product": {
        "bg": "#d9ff66",
        "text": "#000000",
        "textCompact": "rgba(0, 0, 0, 0.48)"
      },
      "rarity": {
        "bg": "#141d1f",
        "text": "#22a8c3"
      },
      "name": {
        "bg": "#ffffff",
        "text": "#000000"
      },
      "account": {
        "bg": "#9580ff",
        "text": "#000000",
        "textCompact": "rgba(0, 0, 0, 0.48)"
      },
      "id": {
        "bg": "#dadbd7",
        "bgSeries": "#000000",
        "textSeries": "#d7dee0",
        "textNumber": "#000000",
        "textCompact": "rgba(0, 0, 0, 0.48)"
      },
      "subentity": {
        "bg": "#a8aaa2",
        "text": "#000000"
      },
      "item": {
        "bg": "#55dcf6",
        "text": "#000000",
        "textCompact": "rgba(0, 0, 0, 0.48)"
      }
    },
    "toast": {
      "bg": "#a9aca0"
    },
    "toggleButton": {
      "bg": "#ecede9",
      "bgHover": "#dddfd8",
      "bgActive": "rgba(128, 234, 255, 0.15)",
      "bgDisable": "rgba(221, 223, 216, 0.65)",
      "border": "#dddfd8",
      "borderHover": "#c2c4ba",
      "borderActive": "#80eaff",
      "borderDisable": "rgba(221, 223, 216, 0)",
      "text": "#000000",
      "textActive": "#000000",
      "textDisable": "rgba(0, 0, 0, 0.2)"
    },
    "appButton": {
      "bg": "#dadbd7",
      "bgHover": "#c1c2bc",
      "bgPress": "#a8aaa2",
      "border": "#c1c2bc",
      "borderHover": "#a8aaa2",
      "borderPress": "rgba(255, 255, 255, 0)",
      "text": "#000000",
      "textDisable": "#999999"
    }
  }
}
